export const contracts = {
  Contracts: 'Contratos',
  Sign: 'Assinar',
  'Sign them to schedule your sessions as soon as possible':
    'Assine-os para poder agendar suas sessões o quanto antes!',
  'You have contracts to sign': 'Você possui contratos para assinar',
  "You will be redirected automatically as soon as you sign the contracts If this doesn't happen, click here":
    'Você será redirecionado automaticamente assim que assinar os contratos. Caso isso não aconteça, clique aqui',
};
